import React from 'react';
import PropTypes from 'prop-types';
import CombinedScoreDial from './CombinedScoreDial';

const CEScoreUpdates = props => <CombinedScoreDial {...props} />;

CEScoreUpdates.propTypes = {
  className: PropTypes.string,
  alt: PropTypes.string,
};

export default CEScoreUpdates;
